import common from './common.json';
import routes from './routes.json';
import login from './login.json';
import payingProcess from './paying-process.json';
import merchant from './merchant.json';
import collect from './collect.json';
import pay from './pay.json';
import funding from './funding.json';
import channel from './channel.json';
import rule from './rule.json';
import statistics from './statistics.json';
import system from './system.json';
import components from './components.json';

export default {
  common,
  routes,
  login,
  payingProcess,
  merchant,
  collect,
  pay,
  funding,
  channel,
  rule,
  statistics,
  system,
  components
};
